import { render, staticRenderFns } from "./DashboardMetrics.vue?vue&type=template&id=32cf20dd&scoped=true&"
import script from "./DashboardMetrics.vue?vue&type=script&lang=js&"
export * from "./DashboardMetrics.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMetrics.vue?vue&type=style&index=0&id=32cf20dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cf20dd",
  null
  
)

export default component.exports